import { produce } from "immer";
import { GlobalActions, resetAction } from "../../globals/store/actions";
import { YoutubeSetting } from "../interface/youtubeSetting";
import {
  initialYoutubeDirectPostDraft,
  YoutubeApiAction,
  YoutubeDirectPostDraft,
  YOUTUBE_BIND_SUCCESS,
  YOUTUBE_GET_INIT,
  YOUTUBE_GET_SUCCESS,
  YOUTUBE_RESET_DIRECT_POST_DRAFT,
  YOUTUBE_SET_DIRECT_POST_DRAFT,
  YOUTUBE_UNBIND_SUCCESS,
} from "./api-actions";

export type { YoutubeDirectPostDraft } from "./api-actions";

export interface YoutubeState {
  settings: YoutubeSetting | null;
  directPostDraft: YoutubeDirectPostDraft;
}

const initialState: YoutubeState = {
  settings: null,
  directPostDraft: initialYoutubeDirectPostDraft,
};

export default function youtubeReducer(
  state = initialState,
  action: YoutubeApiAction | GlobalActions
): YoutubeState {
  switch (action.type) {
    case YOUTUBE_GET_INIT:
      return state;
    case YOUTUBE_GET_SUCCESS:
      return produce(state, (draft) => {
        draft.settings = action.payload.settings;
      });
    case YOUTUBE_BIND_SUCCESS:
      return produce(state, (draft) => {
        draft.settings = action.payload.settings;
      });
    case YOUTUBE_UNBIND_SUCCESS:
      return produce(state, (draft) => {
        draft.settings = null;
        draft.directPostDraft = initialYoutubeDirectPostDraft;
      });
    case YOUTUBE_SET_DIRECT_POST_DRAFT:
      return produce(state, (draft) => {
        Object.assign(draft.directPostDraft, action.payload.draft);
      });
    case YOUTUBE_RESET_DIRECT_POST_DRAFT:
      return produce(state, (draft) => {
        draft.directPostDraft = initialYoutubeDirectPostDraft;
      });
    case resetAction.type:
      return initialState;
    default:
      return state;
  }
}
